module.exports = __webpack_public_path__ + "i18n/languages.4dda689.json";